<div
  [ngClass]="{
    'main-notification': true,
    'success': notification.type === 'success',
    'error': notification.type === 'error',
    'warning': notification.type === 'warning',
    'info': notification.type === 'info',
  }"
>
  <div class="content-wrapper">
    <div class="top-segment">
      <div class="notification-header">
        {{ cap(notification.type) }}
      </div>
    </div>

    <div class="message">
      {{ notification.message }}
    </div>
  </div>

  <div class="exit-button-container">
    <button (click)="onCloseClick()">
      <span class="material-symbols-outlined">&#xe5cd;</span>
    </button>
  </div>
</div>
